export const environment = {
    webappsRootURL: 'https://project3apps.epa.ohio.gov',
    ebizRootURL: 'https://epaproject3apps.epa.ohio.gov',
    clientID: 'dd0bda17-1893-439e-8650-5378ce736e88',
    redirectURI: 'https://gwqcp.project3.epa.ohio.gov/'
};
